import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { Component } from "react";

class ConfirmationDialog extends Component {
  render() {
    const { open, handleClose, handleOk, message } = this.props;
    let dialogMessage = message||"Do you really want to delete this item? This process can not be undone"
    return (
      <Dialog
        onClose={handleClose}
        open={open}
        fullWidth={true}
        maxWidth={"sm"}
        keepMounted
      >
        <DialogTitle className="dialog-title">Are you sure?</DialogTitle>
        <DialogContent className="dialog-content">
          {dialogMessage}
        </DialogContent>
        <DialogActions className="action-buttons">
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleOk} className="delete-confirm-button">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/FormElement/ConfirmationDialog.js